export default __webpack_public_path__ + "static/media/logo.fe86d132.png";